import { Scope } from "@corpuscomplete/core/common/scope";
import { useAuth } from "@corpuscomplete/web/auth/hooks";
import { RecipeCreatePage } from "@corpuscomplete/web/modules/nutrition/recipe/pages/recipe-create";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";

export const Route = createFileRoute("/_authenticated/personal/recipes/create")({
  validateSearch: z.object({
    initialCollectionId: z.uuid().optional(),
  }),
  component: () => {
    const { initialCollectionId } = Route.useSearch();
    const { userId } = useAuth();
    return (
      <RecipeCreatePage initialCollectionId={initialCollectionId} scope={Scope.personal(userId)} />
    );
  },
});
